// extracted by mini-css-extract-plugin
module.exports = {"authWrap":"auth-buttons-group_authWrap__nXmkE","button":"auth-buttons-group_button__3Y82v","headerWrap":"auth-buttons-group_headerWrap__2IVPX"};